
import React from 'react';
import {Card} from 'antd';
import styles from './styles';
import './teamcard.css';

import {FacebookOutlined, WhatsAppOutlined, InstagramOutlined } from '@ant-design/icons';

import img from '../../assets/Images/golden.jpg';

const Teamcard = (props) => {
    return(
        <>
        <Card
            bordered
            style={{margin: '0 20px', backgroundImage: `url(${props.bgImage})`, backgroundPosition: 'center', backgroundRepeat: 'no-repeat', 
                backgroundSize: 'cover'}}
            className="feadtured-card team-card"
             >
                <div className="teamLinks">
                <a href="#"><FacebookOutlined className="team-icon" style={styles.teamIcons}/></a>
                     <a href="#"><WhatsAppOutlined className="team-icon" style={styles.teamIcons}/></a>
                     <a href="#"><InstagramOutlined className="team-icon" style={styles.teamIcons}/></a>
                </div>
                <div className="teamCard">
                    <h3 style={{color: '#fff', letterSpacing: '1px'}}>{props.teamHeading}</h3>
                    <p style={{color: '#fff', letterSpacing: '1px', textTransform: "uppercase"}}>{props.teamPara}</p>
                </div>
                <div className="triangle">
                    <>
                    </>
                </div>
             </Card>
        </>
    )
}
export default Teamcard;